"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeFeedQuerySchema = exports.PageChangeRowSchema = exports.PageChangeKindSchema = exports.PAGE_CHANGE_KIND_CODES = exports.PAGE_CHANGE_KINDS = exports.ChangeSeveritySchema = exports.ReviewReportSchema = exports.ReviewGroupResultSchema = exports.ReviewIssueSchema = exports.ReviewPageRefSchema = exports.ReviewGroupCodeSchema = exports.REVIEW_GROUP_CODES = exports.REVIEW_GROUPS = exports.ReviewSeveritySchema = void 0;
exports.detectChanges = detectChanges;
const zod_1 = require("zod");
const query_1 = require("./query");
/**
 * Rà soát cả danh sách — spec SC-17 (đối chiếu chéo) và SC-19 (thay đổi theo thời gian).
 *
 * Hai spec, một màn hình `/ra-soat`. Ranh giới giữa chúng: SC-17 so các trang VỚI
 * NHAU, SC-19 so một trang với CHÍNH NÓ ở lần quét trước. Cái sau chạy được cả khi
 * danh sách chỉ có một trang.
 *
 * NGUYÊN TẮC CHUNG cho cả hai: **ghi nhận, không chấm điểm**. Ba con số của mỗi
 * trang giữ nguyên. Thứ tìm được ở đây là thuộc tính của một CẶP hoặc một CHUỖI
 * THỜI GIAN, trừ điểm trang nào cũng đều tuỳ tiện — và nhờ vậy, thêm bớt nhóm về
 * sau không làm lệch lịch sử điểm.
 */
/* ────────────────────────────────────────────────────────────────────────────
 * SC-17 — đối chiếu chéo giữa các trang
 * ──────────────────────────────────────────────────────────────────────────── */
exports.ReviewSeveritySchema = zod_1.z.enum(['nghiem-trong', 'canh-bao']);
/**
 * Sáu nhóm đối chiếu — spec SC-17 §4.
 *
 * `hauQua` là câu QUAN TRỌNG NHẤT của mỗi nhóm: người dùng của Copilot là
 * marketing, "trùng canonical" không nói lên điều gì, "một trang sẽ biến mất khỏi
 * Google" thì nói được. Viết hậu quả, đừng viết định nghĩa.
 */
exports.REVIEW_GROUPS = {
    'title-trung': {
        label: 'Trùng Meta Title',
        severity: 'nghiem-trong',
        hauQua: 'Google phải tự chọn một trang để hiển thị cho cùng một tiêu đề, và các trang còn lại tranh chỗ lẫn nhau. Mỗi trang cần một tiêu đề riêng.',
    },
    'canonical-trung': {
        label: 'Nhiều trang khai cùng một canonical',
        severity: 'nghiem-trong',
        hauQua: 'Đây là cách nói với Google "những trang này là một". Google sẽ giữ MỘT trang trong chỉ mục và bỏ hẳn các trang còn lại — không phải xếp hạng kém đi, mà là biến mất.',
    },
    'canonical-cheo': {
        label: 'Canonical trỏ sang một trang khác đang theo dõi',
        severity: 'nghiem-trong',
        hauQua: 'Trang này đang tự nhường chỗ cho trang kia. Nếu đó là chủ ý thì bỏ trang này khỏi danh sách theo dõi; nếu không thì sửa khai báo canonical về chính nó.',
    },
    noindex: {
        label: 'Trang tự chặn lập chỉ mục',
        severity: 'nghiem-trong',
        hauQua: 'Thẻ robots có "noindex" — trang không thể xuất hiện trên Google dù điểm SEO cao đến đâu. Thường là sót lại từ lúc chạy thử.',
    },
    'description-trung': {
        label: 'Trùng Meta Description',
        severity: 'canh-bao',
        hauQua: 'Không ảnh hưởng xếp hạng, nhưng đoạn mô tả dưới tiêu đề trên Google là thứ quyết định người ta có bấm vào không. Trùng nghĩa là chưa ai viết riêng cho từng trang.',
    },
    'h1-trung': {
        label: 'Trùng tiêu đề H1',
        severity: 'canh-bao',
        hauQua: 'Hai trang đang tự giới thiệu bằng cùng một câu. Google và người đọc đều khó phân biệt chúng khác nhau ở đâu.',
    },
};
exports.REVIEW_GROUP_CODES = Object.keys(exports.REVIEW_GROUPS);
exports.ReviewGroupCodeSchema = zod_1.z.enum(exports.REVIEW_GROUP_CODES);
/** Một trang xuất hiện trong kết quả rà soát. */
exports.ReviewPageRefSchema = zod_1.z.object({
    slug: zod_1.z.string(),
    code: zod_1.z.string(),
    publicUrl: zod_1.z.string(),
});
/**
 * Một vấn đề: giá trị bị trùng (hoặc địa chỉ bị trỏ tới) + các trang liên quan.
 *
 * Nhóm `noindex` không có giá trị chung nào để hiện, `giaTri` khi đó là null —
 * mỗi trang tự nó là một vấn đề, không phải một cặp.
 */
exports.ReviewIssueSchema = zod_1.z.object({
    giaTri: zod_1.z.string().nullable(),
    pages: zod_1.z.array(exports.ReviewPageRefSchema),
});
exports.ReviewGroupResultSchema = zod_1.z.object({
    code: exports.ReviewGroupCodeSchema,
    issues: zod_1.z.array(exports.ReviewIssueSchema),
    /** Tổng số trang dính vào nhóm này — để hiện con số mà không phải cộng ở giao diện */
    soTrang: zod_1.z.number().int(),
});
exports.ReviewReportSchema = zod_1.z.object({
    groups: zod_1.z.array(exports.ReviewGroupResultSchema),
    /** Tổng số trang trong phạm vi người xem */
    tongSoTrang: zod_1.z.number().int(),
    /**
     * Số trang CHƯA QUÉT lần nào — không có dữ liệu để đối chiếu.
     * Bắt buộc hiện: "không tìm thấy vấn đề nào" trên một danh sách mà một nửa chưa
     * quét là câu trả lời sai (spec SC-17 §4 Y7).
     */
    chuaQuet: zod_1.z.number().int(),
});
/* ────────────────────────────────────────────────────────────────────────────
 * SC-19 — thay đổi giữa hai lần quét
 * ──────────────────────────────────────────────────────────────────────────── */
exports.ChangeSeveritySchema = zod_1.z.enum(['nghiem-trong', 'ghi-nhan']);
/**
 * Mười loại thay đổi được theo dõi — spec SC-19 §4 Y1.
 *
 * Hai mức, và chỉ hai. Một thay đổi KHÔNG phải lỗi: đổi tiêu đề là việc bình
 * thường. `nghiem-trong` dành cho thứ gần như chắc chắn ngoài ý muốn và có hậu
 * quả đo được; còn lại là `ghi-nhan` — chỉ cần người phụ trách biết để xác nhận
 * đó là chủ ý.
 */
exports.PAGE_CHANGE_KINDS = {
    'noindex-them': {
        label: 'Trang bắt đầu tự chặn lập chỉ mục',
        severity: 'nghiem-trong',
        giaiThich: 'Trang vừa được gắn thẻ noindex — nó sẽ rời khỏi kết quả tìm kiếm của Google.',
    },
    'canonical-mat': {
        label: 'Mất khai báo canonical',
        severity: 'nghiem-trong',
        giaiThich: 'Trang từng khai bản chuẩn, giờ không còn — Google có thể coi các biến thể URL là nội dung trùng lặp.',
    },
    'canonical-doi': {
        label: 'Canonical trỏ sang địa chỉ khác',
        severity: 'nghiem-trong',
        giaiThich: 'Bản chuẩn của trang vừa đổi đích. Nếu ngoài ý muốn thì trang đang tự nhường chỗ cho một địa chỉ khác.',
    },
    'noi-dung-hut': {
        label: 'Nội dung hụt trên 40%',
        severity: 'nghiem-trong',
        giaiThich: 'Số từ giảm mạnh — thường là một khối nội dung không còn hiện, hoặc trang chuyển sang dựng bằng JavaScript.',
    },
    'http-loi': {
        label: 'Trang trả về mã lỗi',
        severity: 'nghiem-trong',
        giaiThich: 'Máy chủ trả về mã lỗi thay vì nội dung. Người dùng và Google đều không đọc được trang.',
    },
    'diem-tut': {
        label: 'Điểm SEO tụt từ 10 điểm trở lên',
        severity: 'nghiem-trong',
        giaiThich: 'Mức tụt này không đến từ nhiễu — có thứ gì đó trong trang vừa đổi.',
    },
    'noindex-bo': {
        label: 'Trang bỏ chặn lập chỉ mục',
        severity: 'ghi-nhan',
        giaiThich: 'Thẻ noindex đã được gỡ — trang có thể vào lại chỉ mục Google.',
    },
    'title-doi': {
        label: 'Đổi Meta Title',
        severity: 'ghi-nhan',
        giaiThich: 'Tiêu đề hiển thị trên Google vừa đổi.',
    },
    'description-doi': {
        label: 'Đổi Meta Description',
        severity: 'ghi-nhan',
        giaiThich: 'Đoạn mô tả dưới tiêu đề trên Google vừa đổi.',
    },
    'h1-doi': {
        label: 'Đổi tiêu đề H1',
        severity: 'ghi-nhan',
        giaiThich: 'Tiêu đề chính hiển thị trên trang vừa đổi.',
    },
};
exports.PAGE_CHANGE_KIND_CODES = Object.keys(exports.PAGE_CHANGE_KINDS);
exports.PageChangeKindSchema = zod_1.z.enum(exports.PAGE_CHANGE_KIND_CODES);
exports.PageChangeRowSchema = zod_1.z.object({
    id: zod_1.z.string(),
    kind: exports.PageChangeKindSchema,
    severity: exports.ChangeSeveritySchema,
    before: zod_1.z.string().nullable(),
    after: zod_1.z.string().nullable(),
    createdAt: zod_1.z.coerce.date(),
    /** Null khi danh sách đã thuộc về một trang cụ thể (màn chi tiết) */
    pageSlug: zod_1.z.string().nullable(),
    pageCode: zod_1.z.string().nullable(),
});
exports.ChangeFeedQuerySchema = zod_1.z.object({
    /** Chỉ lấy mức nghiêm trọng — để trả lời nhanh "tuần này có gì đáng lo không" */
    onlySerious: query_1.QueryBooleanSchema.default(false),
    limit: zod_1.z.coerce.number().int().min(1).max(200).default(50),
});
/** Ngưỡng hụt nội dung. Số từ nhấp nhô vài phần trăm giữa hai lần quét là bình
 *  thường (khối tin tức, năm trong footer); 40% là mất hẳn một phần trang. */
const NGUONG_HUT = 0.4;
/** Điểm SEO tụt từ đây trở lên mới coi là sự kiện, dưới nữa là nhiễu chấm điểm. */
const NGUONG_TUT_DIEM = 10;
/** Cắt cho vừa một dòng danh sách — `before`/`after` chỉ để hiển thị. */
const MAX_LEN = 200;
function cat(v) {
    if (v === null)
        return null;
    return v.length > MAX_LEN ? `${v.slice(0, MAX_LEN)}…` : v;
}
function detectChanges(truoc, sau) {
    if (truoc === null)
        return [];
    const out = [];
    const them = (kind, before, after) => out.push({ kind, severity: exports.PAGE_CHANGE_KINDS[kind].severity, before: cat(before), after: cat(after) });
    if (!truoc.noindex && sau.noindex)
        them('noindex-them', 'cho phép lập chỉ mục', 'noindex');
    if (truoc.noindex && !sau.noindex)
        them('noindex-bo', 'noindex', 'cho phép lập chỉ mục');
    if (truoc.canonical && !sau.canonical)
        them('canonical-mat', truoc.canonical, null);
    else if (truoc.canonical && sau.canonical && truoc.canonical !== sau.canonical) {
        them('canonical-doi', truoc.canonical, sau.canonical);
    }
    // So theo TỈ LỆ chứ không theo số từ tuyệt đối: mất 200 từ trên một trang 300 từ
    // và trên một trang 5 000 từ là hai chuyện hoàn toàn khác nhau.
    if (truoc.wordCount > 0) {
        const tiLeGiam = (truoc.wordCount - sau.wordCount) / truoc.wordCount;
        if (tiLeGiam > NGUONG_HUT) {
            them('noi-dung-hut', `${truoc.wordCount} từ`, `${sau.wordCount} từ`);
        }
    }
    // Chỉ báo khi VỪA CHUYỂN sang lỗi. Trang hỏng suốt ba tuần thì tuần nào cũng
    // sinh một dòng mới là biến dòng thời gian thành nơi lặp lại một tin cũ.
    const loiTruoc = truoc.httpStatus >= 400;
    const loiSau = sau.httpStatus >= 400;
    if (!loiTruoc && loiSau)
        them('http-loi', String(truoc.httpStatus), String(sau.httpStatus));
    if (truoc.seoScore - sau.seoScore >= NGUONG_TUT_DIEM) {
        them('diem-tut', `${truoc.seoScore} điểm`, `${sau.seoScore} điểm`);
    }
    if (truoc.title !== sau.title)
        them('title-doi', truoc.title, sau.title);
    if (truoc.metaDescription !== sau.metaDescription) {
        them('description-doi', truoc.metaDescription, sau.metaDescription);
    }
    if (truoc.h1 !== sau.h1)
        them('h1-doi', truoc.h1, sau.h1);
    return out;
}
//# sourceMappingURL=review.js.map